module.exports = __webpack_public_path__ + "img/edit.b4bc7294.svg";